

















import { Component, Prop } from "vue-property-decorator";
import { DialogComponent } from "vue-modal-dialogs";

import HolidayPeriodProductGroupForm from "./Form.vue";

@Component({
  components: {
    HolidayPeriodProductGroupForm,
  },
})
export default class HolidayPeriodProductGroupDialog extends DialogComponent<
  { name: string; productIds: string[] } | undefined
> {
  @Prop({ default: false })
  public readonly editing!: boolean;

  @Prop({ default: "" })
  public readonly name!: string;

  @Prop({ default: () => [] })
  public readonly productIds!: string[];

  @Prop({ default: () => [] })
  public readonly unavailableProductIds!: string[];
}
